<template>
  <div class="__Login">
    <div class="__Login-Wrapper">
      <div class="__Login-Logo">
        <div class="__Login-LogoMain">
          <img alt="Wave Pro" src="../assets/img/wave-logo.svg" width="150" />
        </div>

        <div class="__Login-LogoSub">
          <Chip label="PRO" color="primary" size="14px" class="glossy chip" square />
        </div>

        <div class="__Login-Version" v-if="currentEnv === 'next'">NEXT {{ appVersion }}</div>
      </div>

      <div class="__Login-Content">
        <router-view name="content" />
      </div>

      <!--<div class="__Login-Footer">-->
      <!--  <div class="__Login-Footer-ResetPasswordLink">-->
      <!--    <router-link to="login/password">{{ $t('Reset password') }}</router-link> -->
      <!--  </div>-->

      <!--  <ButtonDropdown-->
      <!--    :label="localeName(locale)"-->
      <!--    color="standard"-->
      <!--    size="xs"-->
      <!--    outline-->
      <!--    flat-->
      <!--    :items="[-->
      <!--      { key: 'en', label: localeName('en') },-->
      <!--      { key: 'ja', label: localeName('ja') },-->
      <!--    ]"-->
      <!--    @click="changeLocale"-->
      <!--  />-->
      <!--</div>-->
    </div>

    <div class="__Login-AppVersion">ver {{ appVersion }}</div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { changeLanguage } from '@/lib/changeLanguageFn';
import Config from '@/config';

import Chip from '@design-system/components/Chip.vue';
import ButtonDropdown from '@design-system/components/ButtonDropdown.vue';

import LoginForm from '@/pages/Login/LoginForm';
import ChangePasswordWrapper from '@/pages/Login/ChangePassword/Wrapper';

export default {
  components: {
    LoginForm,
    ChangePasswordWrapper,
    Chip,
    ButtonDropdown,
  },
  data() {
    return {
      locale: '',
    };
  },
  watch: {
    //locale(value) {
    //  Cookies.set('mo-wave-locale', value, {
    //    expires: 300,
    //  });
    //},
  },
  created() {
    const storedLocale = Cookies.get('mo-wave-locale');
    this.locale = storedLocale ? storedLocale : 'en';
  },
  computed: {
    appVersion() {
      return Config.version;
    },

    currentEnv() {
      return process.env.VUE_APP_MODE;
    },
  },
  methods: {
    localeName(locale) {
      switch (locale) {
        case 'en':
          return 'English';
        case 'ja':
          return '日本語';
        default:
          return locale;
      }
    },

    changeLocale(locale) {
      this.locale = locale;
      changeLanguage(locale);

      // Save to Cookie
      Cookies.set('mo-wave-locale', locale, {
        expires: 365,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/mo-custom';
.__Login {
  &-Wrapper {
    position: relative;
    width: 400px;
    border: 1px solid $border-color;
    border-radius: 5px;
    background-color: $foundation-color;
    margin: 8rem auto 0;
    padding-top: $space-sm;
  }

  &-Logo {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $space-xxl;
  }

  &-LogoMain {
    margin-right: $space-sm;
  }

  &-LogoSub {
    top: 7px;
    left: 190px;
    z-index: 4000;
    font-size: 1.75rem;
    font-weight: 800;
    color: #000000;

    .chip::v-deep {
      transform: skewX(-20deg);
      position: relative;
      top: 1px;
      left: -2px;

      .ellipsis {
        transform: skewX(20deg);
      }
    }
  }

  &-Version {
    position: absolute;
    top: 77px;
    left: 197px;
    font-size: 12px;
    line-height: 1;
    font-weight: bold;
  }

  &-AppVersion {
    max-width: 400px;
    margin: 0 auto;
    padding: 0 0.5rem;
    text-align: right;
    color: $neutral-secondary-color;
    font-size: 0.8em;
  }

  &-Content {
    margin-bottom: $space-xxl;
    padding: $space-xxl;
  }

  &-Footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-Footer-ResetPasswordLink {
    font-size: $font-size-sm;
    margin-left: $space-md;
  }
}
</style>
